import React, { useMemo } from "react";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/material";

export default function FunnelStageCard({
  label,
  configured,
  volume,
  conversionRate,
  onClick,
}) {
  const statusLabel = configured ? "Configurada" : "Não configurada";
  const statusColor = configured ? "success" : "default";

  const conversionLabel = useMemo(() => {
    if (conversionRate == null || Number.isNaN(Number(conversionRate))) return "—";
    const n = Number(conversionRate);
    return `${Math.round(n * 1000) / 10}%`;
  }, [conversionRate]);

  return (
    <Card
      variant="outlined"
      sx={{ cursor: "pointer", "&:hover": { borderColor: "primary.main" } }}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick?.();
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between">
          <Box>
            <Typography fontWeight={900}>{label}</Typography>
            <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
              <Chip size="small" label={statusLabel} color={statusColor} />
              <Chip size="small" label={`Volume: ${volume ?? "—"}`} variant="outlined" />
              <Chip size="small" label={`Conversão: ${conversionLabel}`} variant="outlined" />
            </Stack>
          </Box>
          <Button size="small" variant={configured ? "outlined" : "contained"} onClick={(e) => { e.stopPropagation(); onClick?.(); }}>
            {configured ? "Editar" : "Configurar"}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

